import { useEffect } from "react";
import { Footer } from "@/components/lunar/Footer";
import { PillsHeader } from "@/components/venue/VenueHero";
import { NetworkingHero } from "@/components/networking/NetworkingHero";
import { NetworkVisualStrip } from "@/components/networking/NetworkVisualStrip";
import {
    NetworkingHow,
    NetworkingWhoMightYouFind,
    NetworkingRecommendation,
    NetworkingRemembers,
    NetworkingPlaces,
    NetworkingFinalCta,
} from "@/components/networking/NetworkingSections";

export default function Networking() {
    useEffect(() => {
        document.title = "Lunar Networking — Meet the right people";
        return () => {
            document.title = "Lunar — The social network for real life";
        };
    }, []);

    return (
        <div data-testid="networking-page">
            <PillsHeader />
            <main>
                <NetworkingHero />
                <NetworkingHow />
                <NetworkingWhoMightYouFind />
                <NetworkVisualStrip />
                <NetworkingRecommendation />
                <NetworkingRemembers />
                <NetworkingPlaces />
                <NetworkingFinalCta />
            </main>
            <Footer />
        </div>
    );
}
